interface UseJSON {
  toJSON: <T>(data: T) => string
  parseJSON: <T>(text: string) => T | undefined
}

export const useJSON = (): UseJSON => {
  const toJSON = <T>(data: T): string => {
    return JSON.stringify(data)
  }

  const parseJSON = <T>(text: string): T | undefined => {
    return JSON.parse(text)
  }

  return { toJSON, parseJSON }
}
